<template>
    <div class="card">
        <div class="card-header">
            <div class="row">
                <div class="col-12" v-if="!isView">
                    <np-checkbox
                            :id="`${bundle_key}_selected`"
                            :name="`quote${bundle_key}[selected]`"
                            :no-wrapper="true"
                            :disabled="isView"
                            :required="!hasSelectedTerminals && !hasSelectedBundlePackage"
                            :description="bundle_package.bundle_name"
                            v-model="bundle_package.is_boarding_activated"
                            @change="$emit('bundle-toggled', bundle_package)"
                            :on-selected="toggleSelectBundlePackage"
                            :on-deselected="function() {
                                bundle_package.bundle_items.forEach(bundle_item => {
                                    bundle_item.terminal_quantity = 0;
                                    bundle_item.selected = false;
                                    bundle_item.is_boarding_activated = '0';
                                })
                            }">
                    </np-checkbox>
                </div>
                <div class="col-12" v-else>
                    <span> {{bundle_package.bundle_name}}</span>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div v-if="bundlePackageHasEquipments">
<!--                <div :id="`terminals${bundle_key}`" class="card">-->
<!--                    <div class="card-header cursorPointer" @click="toggleAccordionSection(bundle_terminals_block)"-->
<!--                         :id="`heading_terminal${bundle_key}`" data-bs-toggle="collapse" :data-bs-target="`#collapse_terminal${bundle_key}`"-->
<!--                         aria-expanded="true" :aria-controls="`collapse_terminal${bundle_key}`">-->
<!--                        <h5 class="mb-0">-->
<!--                            <span v-if="bundle_terminals_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>-->
<!--                            <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>-->
<!--                            <span>{{lang('equipments')}}</span>-->
<!--                            <span class="badge badge-info">{{numberSelectedBundlePackageTerminals}} {{lang('selected')}}</span>-->
<!--                        </h5>-->
<!--                    </div>-->
<!--                    <div :data-bs-parent="`#accordionOneBundlePackage${bundle_key}`" :id="`collapse_terminal${bundle_key}`" :aria-labelledby="`heading_terminal${bundle_key}`" class="collapse card-body">-->
                        <div class="row">
                            <template  v-for="(bundle_item, item_idx) in bundle_package.bundle_items">
                                <div class="col-12"
                                     v-if="isEquipment(bundle_item) && bundle_item.display">
                                    <equipment-terminals
                                        :is-view="isView"
                                        :bundle_item="bundle_item"
                                        :is-bundle-package="true"
                                        :bundle-package-selected="bundle_package.is_boarding_activated === '1'"
                                        :id="`quote_equipment_offer_bundle_package_${bundle_key}_bundle_item${item_idx}`"
                                        :name="`quote[equipment_offer][bundle_package][${bundle_key}][bundle_item][${item_idx}]`">
                                    </equipment-terminals>
                                </div>
                            </template>
                        </div>
<!--                    </div>-->
<!--                </div>-->
            </div>
            <div v-if="bundlePackageHasAccessories">
<!--                <div :id="`accessories${bundle_key}`" class="card">-->
<!--                    <div class="card-header cursorPointer" @click="toggleAccordionSection(bundle_accessories_block)"-->
<!--                         :id="`heading_accessories${bundle_key}`" data-bs-toggle="collapse" :data-bs-target="`#collapse_accessories${bundle_key}`"-->
<!--                         aria-expanded="true" :aria-controls="`collapse_accessories${bundle_key}`">-->
<!--                        <h5 class="mb-0">-->
<!--                            <span v-if="bundle_accessories_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>-->
<!--                            <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>-->
<!--                            <span>{{lang('equipment_accessories')}}</span>-->
<!--                            <span class="badge badge-info">{{numberSelectedBundlePackageAccessories}} {{lang('selected')}}</span>-->
<!--                        </h5>-->
<!--                    </div>-->
<!--                    <div :data-bs-parent="`#accordionTwoBundlePackage${bundle_key}`" :id="`collapse_accessories${bundle_key}`" :aria-labelledby="`heading_accessories${bundle_key}`" class="collapse card-body">-->
                        <div class="row">
                            <div class="col-12">
                                <div class="panel-sub-heading headingSmall">
                                    <span class="markedBottom">{{lang('equipment_accessories')}}</span>
                                </div>
                            </div>
                            <template v-for="(bundle_item, item_idx) in bundle_package.bundle_items">
                                <div class="col-12" v-if="isAccessory(bundle_item) && bundle_item.display">
                                    <equipment-terminals
                                        :is-view="isView"
                                        :bundle_item="bundle_item"
                                        :is-bundle-package="true"
                                        :bundle-package-selected="bundle_package.is_boarding_activated === '1'"
                                        :id="`quote_equipment_offer_bundle_package_${bundle_key}_bundle_item${item_idx}`"
                                        :name="`quote[equipment_offer][bundle_package][${bundle_key}][bundle_item][${item_idx}]`">
                                    </equipment-terminals>
                                </div>
                            </template>
                        </div>
<!--                    </div>-->
<!--                </div>-->
            </div>
            <div v-if="bundlePackageHasServices">
<!--                <div :id="`terminal_services${bundle_key}`" class="card">-->
<!--                    <div class="card-header cursorPointer" @click="toggleAccordionSection(bundle_terminal_services_block)"-->
<!--                         :id="`heading_terminal_services${bundle_key}`" data-bs-toggle="collapse" :data-bs-target="`#collapse_terminal_services${bundle_key}`"-->
<!--                         aria-expanded="true" :aria-controls="`collapse_terminal_services${bundle_key}`">-->
<!--                        <h5 class="mb-0">-->
<!--                            <span v-if="bundle_terminal_services_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>-->
<!--                            <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>-->
<!--                            <span>{{lang('equipment_services')}}</span>-->
<!--                            <span class="badge badge-info">{{numberSelectedBundlePackageServices}} {{lang('selected')}}</span>-->
<!--                        </h5>-->
<!--                    </div>-->
<!--                    <div :data-bs-parent="`#accordionThreeBundlePackage${bundle_key}`" :id="`collapse_terminal_services${bundle_key}`" :aria-labelledby="`heading_terminal_services${bundle_key}`" class="collapse card-body">-->
                        <div class="row">
                            <div class="col-12">
                                <div class="panel-sub-heading headingSmall">
                                    <span class="markedBottom">{{lang('equipment_services')}}</span>
                                </div>
                            </div>
                            <template v-for="(bundle_item, item_idx) in bundle_package.bundle_items">
                                <div class="col-12" v-if="isService(bundle_item)">
                                    <equipment-services :bundle_item="bundle_item"
                                                        :is-view="isView"
                                                        :is-standalone="false"
                                                        :is-bundle-package="true"
                                                        :bundle-package-selected="bundle_package.is_boarding_activated === '1'"
                                                        :id="`quote_equipment_offer_bundle_package_${bundle_key}_bundle_item${item_idx}`"
                                                        :name="`quote[equipment_offer][bundle_package][${bundle_key}][bundle_item][${item_idx}]`">
                                    </equipment-services>
                                </div>
                            </template>
                        </div>
<!--                    </div>-->
<!--                </div>-->
            </div>
            <div v-if="bundlePackageHasGeneralServices">
<!--                <div :id="`general_services${bundle_key}`" class="card">-->
<!--                    <div class="card-header cursorPointer" @click="toggleAccordionSection(bundle_general_services_block)"-->
<!--                         :id="`heading_general_services${bundle_key}`" data-bs-toggle="collapse" :data-bs-target="`#collapse_general_services${bundle_key}`"-->
<!--                         aria-expanded="true" :aria-controls="`collapse_general_services${bundle_key}`">-->
<!--                        <h5 class="mb-0">-->
<!--                            <span v-if="bundle_general_services_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>-->
<!--                            <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>-->
<!--                            <span>{{lang('services')}}</span>-->
<!--                            <span class="badge badge-info">{{numberSelectedBundlePackageGeneralServices}} {{lang('selected')}}</span>-->
<!--                        </h5>-->
<!--                    </div>-->
<!--                    <div :data-bs-parent="`#accordionFiveBundlePackage${bundle_key}`" :id="`collapse_general_services${bundle_key}`" :aria-labelledby="`heading_general_services${bundle_key}`" class="collapse card-body">-->
                        <div class="row">

                            <div class="col-12">
                                <div class="panel-sub-heading headingSmall">
                                    <span class="markedBottom">{{lang('services')}}</span>
                                </div>
                            </div>
                            <template v-for="(bundle_item, item_idx) in bundle_package.bundle_items">
                                <div class="col-12" v-if="isGeneralService(bundle_item)">
                                    <equipment-services :bundle_item="bundle_item"
                                                        :is-view="isView"
                                                        :is-standalone="false"
                                                        :is-bundle-package="true"
                                                        :bundle-package-selected="bundle_package.is_boarding_activated === '1'"
                                                        :id="`quote_equipment_offer_bundle_package_${bundle_key}_bundle_item${item_idx}`"
                                                        :name="`quote[equipment_offer][bundle_package][${bundle_key}][bundle_item][${item_idx}]`">
                                    </equipment-services>
                                </div>
                            </template>
                        </div>
<!--                    </div>-->
<!--                </div>-->
            </div>
            <div>
<!--                <div :id="`accordionOneBundlePackage${bundle_key}`" v-if="bundlePackageHasEquipments">&ndash;&gt;-->
                    <!--                <div :id="`terminals${bundle_key}`" class="card">-->
                    <!--                    <div class="card-header cursorPointer" @click="toggleAccordionSection(bundle_terminals_block)"-->
                    <!--                         :id="`heading_terminal${bundle_key}`" data-bs-toggle="collapse" :data-bs-target="`#collapse_terminal${bundle_key}`"-->
                    <!--                         aria-expanded="true" :aria-controls="`collapse_terminal${bundle_key}`">-->
                    <!--                        <h5 class="mb-0">-->
                    <!--                            <span v-if="bundle_terminals_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>-->
                    <!--                            <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>-->
                    <!--                            <span>{{lang('equipments')}}</span>-->
                    <!--                            <span class="badge badge-info">{{numberSelectedBundlePackageTerminals}} {{lang('selected')}}</span>-->
                    <!--                        </h5>-->
                    <!--                    </div>-->
                    <!--                    <div :data-bs-parent="`#accordionOneBundlePackage${bundle_key}`" :id="`collapse_terminal${bundle_key}`" :aria-labelledby="`heading_terminal${bundle_key}`" class="collapse card-body">-->
                    <!--                        <div class="row">-->
                    <!--                            <template>-->
                    <!--                                <div class="col-12"-->
                    <!--                                     v-for="(bundle_item, item_idx) in bundle_package.bundle_items"-->
                    <!--                                     v-if="isEquipment(bundle_item) && bundle_item.display">-->
                    <!--                                    <equipment-terminals-->
                    <!--                                            :is-view="isView"-->
                    <!--                                            :bundle_item="bundle_item"-->
                    <!--                                            :is-bundle-package="true"-->
                    <!--                                            :bundle-package-selected="bundle_package.is_boarding_activated === '1'"-->
                    <!--                                            :id="`quote_equipment_offer_bundle_package_${bundle_key}_bundle_item${item_idx}`"-->
                    <!--                                            :name="`quote[equipment_offer][bundle_package][${bundle_key}][bundle_item][${item_idx}]`">-->
                    <!--                                    </equipment-terminals>-->
                    <!--                                </div>-->
                    <!--                            </template>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <!--                </div>-->
                    <!--            </div>-->
                    <!--            <div :id="`accordionTwoBundlePackage${bundle_key}`" v-if="bundlePackageHasAccessories">-->
                    <!--                <div :id="`accessories${bundle_key}`" class="card">-->
                    <!--                    <div class="card-header cursorPointer" @click="toggleAccordionSection(bundle_accessories_block)"-->
                    <!--                         :id="`heading_accessories${bundle_key}`" data-bs-toggle="collapse" :data-bs-target="`#collapse_accessories${bundle_key}`"-->
                    <!--                         aria-expanded="true" :aria-controls="`collapse_accessories${bundle_key}`">-->
                    <!--                        <h5 class="mb-0">-->
                    <!--                            <span v-if="bundle_accessories_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>-->
                    <!--                            <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>-->
                    <!--                            <span>{{lang('equipment_accessories')}}</span>-->
                    <!--                            <span class="badge badge-info">{{numberSelectedBundlePackageAccessories}} {{lang('selected')}}</span>-->
                    <!--                        </h5>-->
                    <!--                    </div>-->
                    <!--                    <div :data-bs-parent="`#accordionTwoBundlePackage${bundle_key}`" :id="`collapse_accessories${bundle_key}`" :aria-labelledby="`heading_accessories${bundle_key}`" class="collapse card-body">-->
                    <!--                        <div class="row">-->
                    <!--                            <template>-->
                    <!--                                <div class="col-12" v-for="(bundle_item, item_idx) in bundle_package.bundle_items"-->
                    <!--                                     v-if="isAccessory(bundle_item) && bundle_item.display">-->
                    <!--                                    <equipment-terminals-->
                    <!--                                            :is-view="isView"-->
                    <!--                                            :bundle_item="bundle_item"-->
                    <!--                                            :is-bundle-package="true"-->
                    <!--                                            :bundle-package-selected="bundle_package.is_boarding_activated === '1'"-->
                    <!--                                            :id="`quote_equipment_offer_bundle_package_${bundle_key}_bundle_item${item_idx}`"-->
                    <!--                                            :name="`quote[equipment_offer][bundle_package][${bundle_key}][bundle_item][${item_idx}]`">-->
                    <!--                                    </equipment-terminals>-->
                    <!--                                </div>-->
                    <!--                            </template>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <!--                </div>-->
                    <!--            </div>-->
                    <!--            <div :id="`accordionThreeBundlePackage${bundle_key}`" v-if="bundlePackageHasServices">-->
                    <!--                <div :id="`terminal_services${bundle_key}`" class="card">-->
                    <!--                    <div class="card-header cursorPointer" @click="toggleAccordionSection(bundle_terminal_services_block)"-->
                    <!--                         :id="`heading_terminal_services${bundle_key}`" data-bs-toggle="collapse" :data-bs-target="`#collapse_terminal_services${bundle_key}`"-->
                    <!--                         aria-expanded="true" :aria-controls="`collapse_terminal_services${bundle_key}`">-->
                    <!--                        <h5 class="mb-0">-->
                    <!--                            <span v-if="bundle_terminal_services_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>-->
                    <!--                            <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>-->
                    <!--                            <span>{{lang('equipment_services')}}</span>-->
                    <!--                            <span class="badge badge-info">{{numberSelectedBundlePackageServices}} {{lang('selected')}}</span>-->
                    <!--                        </h5>-->
                    <!--                    </div>-->
                    <!--                    <div :data-bs-parent="`#accordionThreeBundlePackage${bundle_key}`" :id="`collapse_terminal_services${bundle_key}`" :aria-labelledby="`heading_terminal_services${bundle_key}`" class="collapse card-body">-->
                    <!--                        <div class="row">-->
                    <!--                            <template>-->
                    <!--                                <div class="col-12" v-for="(bundle_item, item_idx) in bundle_package.bundle_items"-->
                    <!--                                     v-if="isService(bundle_item)">-->
                    <!--                                    <equipment-services :bundle_item="bundle_item"-->
                    <!--                                                        :is-view="isView"-->
                    <!--                                                        :is-standalone="false"-->
                    <!--                                                        :is-bundle-package="true"-->
                    <!--                                                        :bundle-package-selected="bundle_package.is_boarding_activated === '1'"-->
                    <!--                                                        :id="`quote_equipment_offer_bundle_package_${bundle_key}_bundle_item${item_idx}`"-->
                    <!--                                                        :name="`quote[equipment_offer][bundle_package][${bundle_key}][bundle_item][${item_idx}]`">-->
                    <!--                                    </equipment-services>-->
                    <!--                                </div>-->
                    <!--                            </template>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <!--                </div>-->
                    <!--            </div>-->
                    <!--            <div :id="`accordionFiveBundlePackage${bundle_key}`" v-if="bundlePackageHasGeneralServices">-->
                    <!--                <div :id="`general_services${bundle_key}`" class="card">-->
                    <!--                    <div class="card-header cursorPointer" @click="toggleAccordionSection(bundle_general_services_block)"-->
                    <!--                         :id="`heading_general_services${bundle_key}`" data-bs-toggle="collapse" :data-bs-target="`#collapse_general_services${bundle_key}`"-->
                    <!--                         aria-expanded="true" :aria-controls="`collapse_general_services${bundle_key}`">-->
                    <!--                        <h5 class="mb-0">-->
                    <!--                            <span v-if="bundle_general_services_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>-->
                    <!--                            <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>-->
                    <!--                            <span>{{lang('services')}}</span>-->
                    <!--                            <span class="badge badge-info">{{numberSelectedBundlePackageGeneralServices}} {{lang('selected')}}</span>-->
                    <!--                        </h5>-->
                    <!--                    </div>-->
                    <!--                    <div :data-bs-parent="`#accordionFiveBundlePackage${bundle_key}`" :id="`collapse_general_services${bundle_key}`" :aria-labelledby="`heading_general_services${bundle_key}`" class="collapse card-body">-->
                    <!--                        <div class="row">-->
                    <!--                            <template>-->
                    <!--                                <div class="col-12" v-for="(bundle_item, item_idx) in bundle_package.bundle_items"-->
                    <!--                                     v-if="isGeneralService(bundle_item)">-->
                    <!--                                    <equipment-services :bundle_item="bundle_item"-->
                    <!--                                                        :is-view="isView"-->
                    <!--                                                        :is-standalone="false"-->
                    <!--                                                        :is-bundle-package="true"-->
                    <!--                                                        :bundle-package-selected="bundle_package.is_boarding_activated === '1'"-->
                    <!--                                                        :id="`quote_equipment_offer_bundle_package_${bundle_key}_bundle_item${item_idx}`"-->
                    <!--                                                        :name="`quote[equipment_offer][bundle_package][${bundle_key}][bundle_item][${item_idx}]`">-->
                    <!--                                    </equipment-services>-->
                    <!--                                </div>-->
                    <!--                            </template>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <!--                </div>-->
                    <!--            </div>-->
                    <!--            <div :id="`accordionFourBundlePackage${bundle_key}`" v-if="bundlePackageHasStandaloneServices">-->
                    <!--                <div :id="`standalone_services${bundle_key}`" class="card">-->
                    <!--                    <div class="card-header cursorPointer" @click="toggleAccordionSection(bundle_standalone_services_block)"-->
                    <!--                         :id="`heading_standalone_services${bundle_key}`" data-bs-toggle="collapse" :data-bs-target="`#collapse_standalone_services${bundle_key}`"-->
                    <!--                         aria-expanded="true" :aria-controls="`collapse_standalone_services${bundle_key}`">-->
                    <!--                        <h5 class="mb-0">-->
                    <!--                            <span v-if="bundle_standalone_services_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>-->
                    <!--                            <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>-->
                    <!--                            <span>{{lang('add_ons')}}</span>-->
                    <!--                            <span class="badge badge-info">{{numberSelectedBundlePackageStandaloneServices}} {{lang('selected')}}</span>-->
                    <!--                        </h5>-->
                    <!--                    </div>-->
                    <!--                    <div :data-bs-parent="`#accordionFourBundlePackage${bundle_key}`" :id="`collapse_standalone_services${bundle_key}`" :aria-labelledby="`heading_standalone_services${bundle_key}`" class="collapse card-body">-->
                    <!--                        <div class="row">-->
                    <!--                            <template>-->
                    <!--                                <div class="col-12" v-for="(bundle_item, item_idx) in bundle_package.bundle_items"-->
                    <!--                                     v-if="isStandaloneService(bundle_item)">-->
                    <!--                                    <equipment-services :bundle_item="bundle_item"-->
                    <!--                                                        :is-view="isView"-->
                    <!--                                                        :is-standalone="false"-->
                    <!--                                                        :is-bundle-package="true"-->
                    <!--                                                        :bundle-package-selected="bundle_package.is_boarding_activated === '1'"-->
                    <!--                                                        :id="`quote_equipment_offer_bundle_package_${bundle_key}_bundle_item${item_idx}`"-->
                    <!--                                                        :name="`quote[equipment_offer][bundle_package][${bundle_key}][bundle_item][${item_idx}]`">-->
                    <!--                                    </equipment-services>-->
                    <!--                                </div>-->
                    <!--                            </template>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <!--                </div>-->
                    <!--            </div>-->
            </div>
        </div>
    </div>
</template>

<script>
    import utilMixin from "../utils/mixins";
    import applicationMixin from "../utils/application-mixin";
    import equipmentMixin from "../utils/equipment-mixin";
    import NpMultiselect from "netpify/components/np-multiselect.vue";
    import {
        NPCheckBox,
        NPEntry,
        NPInput,
        NPNotice,
        NPRadios,
        NPResponsive,
        NPSelect2,
        NPSkeleton
    } from "netpify/components";
    import EquipmentServices from './equipment-services.vue';
    import EquipmentTerminals from './equipment-terminals.vue';
    export default {
        name: "equipment-bundles",
        mixins: [utilMixin, applicationMixin, equipmentMixin],
        components: {
            'np-multiselect': NpMultiselect,
            'np-entry': NPEntry,
            'np-radios': NPRadios,
            'np-input': NPInput,
            'np-select2': NPSelect2,
            'np-responsive': NPResponsive,
            'np-skeleton': NPSkeleton,
            'np-checkbox': NPCheckBox,
            'np-notice': NPNotice,
            'equipment-services': EquipmentServices,
            'equipment-terminals': EquipmentTerminals,
        },
        props: {
            bundle_package: {
                default (){
                    return {}
                }
            },
            bundle_key: {
                default (){
                    return  Math.random().toString()
                }
            },
            isView: Boolean,
        },
        data (){
          return {
              bundle_terminals_block: {
                  is_open: false,
              },
              bundle_accessories_block: {
                  is_open: false,
              },
              bundle_standalone_services_block: {
                  is_open: false,
              },
              bundle_terminal_services_block: {
                  is_open: false,
              },
              bundle_general_services_block: {
                  is_open: false,
              },
          }
        },
        computed: {
            bundlePackageHasItems: function(){
                return this.objectIsNotEmpty(this.bundle_package.bundle_items)
            },
            bundlePackageHasEquipments: function (){
                let vm = this;
                return this.bundlePackageHasItems
                    && this.bundle_package.bundle_items.some(item => item.display && !vm.isAccessory(item))
            },
            bundlePackageHasAccessories: function () {
                let vm = this;
                return this.bundlePackageHasItems
                    && this.bundle_package.bundle_items.some(item => item.display && vm.isAccessory(item))
            },
            bundlePackageHasStandaloneServices: function (){
                let vm = this;
                return this.bundlePackageHasItems
                    && this.bundle_package.bundle_items.some(item => vm.isStandaloneService(item) && item.display)
            },
            bundlePackageHasGeneralServices: function (){
                let vm = this;
                return this.bundlePackageHasItems
                    && this.bundle_package.bundle_items.some(item => vm.isGeneralService(item) && item.display)
            },
            bundlePackageHasServices: function(){
                let vm = this;
                return this.objectIsNotEmpty(this.bundle_package)
                    && this.bundle_package.bundle_items.some(item => vm.isService(item) && item.display)
            },
            numberSelectedBundlePackageTerminals: function () {
                let bundles = this.bundle_package;
                let vm = this;
                return bundles.bundle_items.filter(item =>
                    vm.isEquipment(item) && item.display && vm.bundleItemIsSelected(item) && item.terminal_quantity > 0).length
            },
            numberSelectedBundlePackageServices: function () {
                let bundles = this.bundle_package;
                let vm = this;
                return bundles.bundle_items.filter(item =>
                    vm.isService(item) && item.display && vm.bundleItemIsSelected(item)).length
            },
            numberSelectedBundlePackageAccessories: function (){
                let bundles = this.bundle_package;
                let vm = this;
                return bundles.bundle_items.filter(item =>
                    vm.isAccessory(item) && item.display && vm.bundleItemIsSelected(item)).length
            },
            numberSelectedBundlePackageStandaloneServices: function (){
                let bundles = this.bundle_package;
                let vm = this;
                return bundles.bundle_items.filter(item =>
                    vm.isStandaloneService(item) && item.display && vm.bundleItemIsSelected(item)).length
            },
            numberSelectedBundlePackageGeneralServices: function (){
                let bundles = this.bundle_package;
                let vm = this;
                return bundles.bundle_items.filter(item =>
                    vm.isGeneralService(item) && item.display && vm.bundleItemIsSelected(item)).length
            },
            totalBundleItems: function  (){
                return parseInt(this.numberSelectedBundlePackageAccessories  +
                        this.numberSelectedBundlePackageGeneralServices +
                        this.numberSelectedBundlePackageServices +
                        this.numberSelectedBundlePackageStandaloneServices +
                        this.numberSelectedBundlePackageTerminals);
            }
        },
        methods: {
            toggleSelectBundlePackage: function(is_selected = true) {
                let vm = this;
                this.bundle_package.bundle_items.forEach(bundle_item => {
                    bundle_item.terminal_quantity = is_selected ? 1 : 0;

                    if (vm.isEquipment(bundle_item) || vm.isAccessory(bundle_item)) {
                        //TODO get the pricing
                        if (bundle_item.billing_plans.length > 0){
                        let matched_plan = bundle_item.billing_plans.find( plan => {
                            return plan.billing_length === vm.agreement_length
                        })
                            // bundle_item.terminal_unit_price = matched_plan.
                        }
                    }
                    bundle_item.selected = is_selected;
                    bundle_item.is_boarding_activated = is_selected ? '1' : '0';
                })
            }
        },
    }
</script>

<style scoped>
.card-header .badge {
    float: right;
}
</style>
